"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Footer = function () {
    return (0, jsx_runtime_1.jsx)("footer", { className: "pt-24 print:hidden", children: "\u00A9" });
};
exports.default = Footer;
